if (!customElements.get('related-blogs-slider')) {
  customElements.define(
    'related-blogs-slider',
    class RelatedBlogsSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
      }

      connectedCallback() {
        if (!this.querySelector('.swiper-slide')) return;
        this.initSwiper();
      }

      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy();
          this.swiper = null;
        }
      }

      initSwiper() {
        const swiperEl = this.querySelector('.related-blogs__swiper');
        if (!swiperEl || this.swiper) return;

        const mobileSingle = this.dataset.mobileSingleCard === 'true';
        const mobileSlides = mobileSingle ? 1 : 1.2;

        try {
          this.swiper = new Swiper(swiperEl, {
            slidesPerView: mobileSlides,
            spaceBetween: 12,
            watchOverflow: true,
            observer: true,
            observeParents: true,
            breakpoints: {
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1025: {
                slidesPerView: 3,
                spaceBetween: 12,
              },
            },
            pagination: {
              el: this.querySelector('.swiper-pagination'),
              type: 'fraction',
            },
            navigation: {
              nextEl: this.querySelector('.related-blogs__next'),
              prevEl: this.querySelector('.related-blogs__prev'),
            },
          });
        } catch (error) {
          console.error('Error initializing Related Blogs Swiper:', error);
        }
      }
    },
  );
}
